import { Badge, Box, Button, IconButton, TextField, Typography } from "@material-ui/core";
import { People, Search } from "@material-ui/icons";
import { useGlobalUserSelector } from "@containers/user-selector-modal";
import { FilterListOutlined } from "@material-ui/icons";
import { Color } from "@bonliva-crm/ui";
import { useLocale } from "@hooks";

type Props = {
  boardTitle: string;
  onUserChange: (userId: string) => void;
  onSearch: (search: string) => void;
  onFilterSliderOpen?: () => void;
  prependFilterPanel?: () => React.ReactNode;
  filterIsDirty?: boolean;
};

export function KanbanBoardHeader(props: Props) {
  const { locale } = useLocale();
  const { select } = useGlobalUserSelector();

  const handleSelectUser = () => {
    select({ multi: false }).then((selected) => {
      if (selected.length > 0) {
        props.onUserChange(selected[0]._id);
      }
    });
  };

  const renderFilterPanel = () => {
    const searchField = (
      <TextField
        hiddenLabel
        placeholder={locale.Search}
        variant="outlined"
        size="small"
        InputProps={{ startAdornment: <Search /> }}
        onChange={(e) => props.onSearch(e.target.value)}
      />
    );

    return (
      <Box style={{ display: "flex", gap: 16 }}>
        {props.prependFilterPanel ? props.prependFilterPanel() : null}

        <Box>{searchField}</Box>

        {props.onFilterSliderOpen ? (
          <Box>
            <IconButton
              style={{
                border: `1px solid ${Color.LightGray}`,
                borderRadius: "8px",
                padding: "7px 7px"
              }}
              onClick={() => props.onFilterSliderOpen()}
            >
              <Badge color="primary" variant="dot" invisible={!props.filterIsDirty}>
                <FilterListOutlined htmlColor={Color.Body} />
              </Badge>
            </IconButton>
          </Box>
        ) : null}
      </Box>
    );
  };

  return (
    <Box display="flex" justifyContent="space-between">
      <Box style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <Box>
          <Typography variant="h5">{props.boardTitle}</Typography>
        </Box>

        <Box>
          <Button
            style={{
              border: `1px solid ${Color.LightGray}`,
              borderRadius: "8px"
            }}
            startIcon={<People />}
            variant="outlined"
            onClick={handleSelectUser}
          >
            {locale.switchUserBoard}
          </Button>
        </Box>
      </Box>

      {renderFilterPanel()}
    </Box>
  );
}
